import PropTypes from "prop-types";
import React, { useEffect, useRef } from "react";

// //Import Scrollbar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";
import { fetchMenu } from "store/actions";
import { useSelector, useDispatch } from "react-redux";


const SidebarContent = props => {
  const dispatch = useDispatch();
  const ref = useRef();

  const { menu } = useSelector(state => ({
    menu: state.Login.menu
  }));

  function setMenu() {
    const pathName = props.location.pathname;
    const initMenu = () => {
      new MetisMenu("#side-menu");
      let matchingMenuItem = null;
      const ul = document.getElementById("side-menu");
      const items = ul.getElementsByTagName("a");
      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i];
          break;
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem);
      }
    };
    initMenu();
  }

  // Use ComponentDidMount and ComponentDidUpdate method symultaniously
  useEffect(() => {
    setTimeout(() => {
      setMenu()
    }, 300)
  }, [props.location.pathname]);

  useEffect(() => {
    ref.current.recalculate();
  });

  useEffect(() => {
    if (!menu) {
      dispatch(fetchMenu())
    }
  }, []);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("Menu")} </li>

            <li>
              <Link to="/dashboard" >
                <i className="bx bx-home-circle"></i>
                <span>{props.t("Dashboard")}</span>
              </Link>
            </li>

            {
              menu && menu.map((item, i) => {
                if (item.standalone) {
                  return <li key={'menu' + i}>
                    <Link to={item.path} >
                      <i className={item.icon}></i>
                      <span>{props.t(item.name)}</span>
                    </Link>
                  </li>
                }
                else {
                  const Member = item.member.map((sub_m, idx) => {
                    return <li key={'menu' + i + "_submenu" + idx}>
                      <Link to={sub_m.path}>{props.t(sub_m.name)}</Link>
                    </li>
                  })
                  return <li key={'menu' + i}>
                    <Link to="/#" className="has-arrow">
                      <i className={item.icon}></i>
                      <span>{props.t(item.name)}</span>
                    </Link>
                    <ul className="sub-menu">
                      {Member}
                    </ul>
                  </li>
                }
              })
            }
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(SidebarContent));
